// Switches how many products the grid shows per row and remembers the choice: one or two on phones,
// three, four or six on desktop (data-scope="desktop", the section's column count by default and always offered).
// A saved choice is already on the grid before it paints (snippets/grid-density-init.liquid); this keeps the
// buttons in step and handles the clicks.
if (!customElements.get('grid-density')) {
	class GridDensity extends HTMLElement {
		connectedCallback() {
			this.desktop = this.dataset.scope === 'desktop';
			this.storageKey = this.desktop ? 'grid-density-desktop' : 'grid-density';
			this.buttons = this.querySelectorAll('button[data-columns]');
			this.options = Array.from(this.buttons, (button) => button.dataset.columns);
			this.buttons.forEach((button) => button.addEventListener('click', () => this.set(button.dataset.columns, true)));
			let saved = null;
			try {
				saved = localStorage.getItem(this.storageKey);
			} catch (error) {}
			const fallback = this.desktop ? this.dataset.default : '2';
			this.set(this.options.includes(saved) ? saved : fallback, false);
		}
		set(columns, remember) {
			const grid = document.getElementById('product-grid');
			if (grid) {
				if (this.desktop) {
					// large-up-N applies from 1068px, so phones and tablets keep their own columns.
					this.options.forEach((count) => grid.classList.toggle(`large-up-${count}`, count === columns));
					grid.dataset.desktopColumns = columns;
				} else {
					grid.classList.toggle('small-up-1', columns === '1');
					grid.classList.toggle('small-up-2', columns !== '1');
				}
				this.syncSizes(grid);
			}
			this.buttons.forEach((button) => button.setAttribute('aria-pressed', button.dataset.columns === columns ? 'true' : 'false'));
			if (remember) {
				try {
					localStorage.setItem(this.storageKey, columns);
				} catch (error) {}
			}
		}
		// The card photos' sizes follow the columns now shown, and the browser re-picks the file: phone, tablet (the
		// section's columns) and desktop (the choice) widths. Lazy photos keep 'auto' first (responsive-image).
		syncSizes(grid) {
			const images = grid.querySelectorAll('.product-primary-image');
			if (!images.length) return;
			const tablet = (grid.className.match(/\bmedium-up-(\d)\b/) || [])[1] || '4';
			const desktop = grid.dataset.desktopColumns || tablet;
			const phone = grid.classList.contains('small-up-1') ? '100vw' : '50vw';
			const sizes = `(min-width: 1068px) calc(100vw / ${desktop}), (min-width: 768px) calc(100vw / ${tablet}), ${phone}`;
			images.forEach((image) => image.setAttribute('sizes', image.loading === 'lazy' ? `auto, ${sizes}` : sizes));
		}
	}
	customElements.define('grid-density', GridDensity);
}
